import { Component } from '@angular/core';
import { Auth } from '../../services/auth';

@Component({
  selector: 'app-no-assignment',
  imports: [],
  templateUrl: './no-assignment.html',
  styleUrl: './no-assignment.scss',
})
export class NoAssignment {
  exclaimIcon = 'assets/images/exclaim.svg';
  
  constructor(private authService: Auth) {}

  logout(): void {
    console.log('Logging out...');
    this.authService.initiateLogout();
  }
}
